import * as z from "zod";
import { Capability } from "./capability";

/** What Redo sells: clouds and standalone products, each a grouping of capabilities. */
export const Product = z.enum([
  "aeo",
  "chargebacks",
  "landedCost",
  "marketingCloud",
  "paymentsCloud",
  "reverseLogisticsCloud",
  "shippingCloud",
]);
export type Product = z.infer<typeof Product>;

/** The product each capability belongs to; gates read capabilities, so regrouping moves no gate. */
export const CAPABILITY_PRODUCT = {
  ai: "marketingCloud",
  aeo: "aeo",
  checkoutOptimization: "paymentsCloud",
  contextual: "marketingCloud",
  customerAccounts: "marketingCloud",
  disputes: "chargebacks",
  emailSms: "marketingCloud",
  hsa: "paymentsCloud",
  ims: "shippingCloud",
  landedCost: "landedCost",
  oms: "shippingCloud",
  orderEditing: "marketingCloud",
  orderTracking: "marketingCloud",
  packageProtection: "reverseLogisticsCloud",
  predictiveConversion: "paymentsCloud",
  recover: "marketingCloud",
  recycling: "reverseLogisticsCloud",
  redoManagedReturns: "reverseLogisticsCloud",
  returns: "reverseLogisticsCloud",
  reviews: "marketingCloud",
  supplies: "shippingCloud",
  support: "marketingCloud",
  tnpl: "marketingCloud",
  warranties: "reverseLogisticsCloud",
  withdrawals: "reverseLogisticsCloud",
  wms: "shippingCloud",
} as const satisfies Record<Capability, Product>;

/** No longer sold; kept until their code is removed, so no new surface should gate on them. */
export const RETIRED_CAPABILITIES = [
  "aeo",
  "customerAccounts",
] as const satisfies readonly Capability[];

export function productCapabilities(product: Product): Capability[] {
  return Capability.options.filter(
    (capability) => CAPABILITY_PRODUCT[capability] === product,
  );
}
